var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"clas"},[_c('div',{staticClass:"clas_left",on:{"click":_vm.phone}},[_vm._v("立即 咨询")]),_c('div',{staticClass:"clas_right",on:{"click":_vm.phone}},[_c('img',{attrs:{"src":require("../assets/img/矩形@2x (3).png")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }